import styles from './PunchupPercentPieChart.module.css';
import { ColorPieChart, PieChart, Root } from 'features/common/components/PieChart/CustomPieChart.styles';
import { RawPercentageProps } from 'features/common/components/PieChart/types';

export const PunchupPercentPieChart = ({ color, sizes, sm, rawPercentage }: RawPercentageProps) => {
	const percentage = Math.round(rawPercentage * 100);

	const getPrimaryPercentage = () => {
		if (percentage === 100) return 100;
		if (percentage === 0) return 0;
		if (percentage > 10) return percentage - 7;
		return 4;
	};
	const primaryPercentage = getPrimaryPercentage();
	const secondaryPercentage = primaryPercentage === 0 ? 100 : 100 - primaryPercentage - 7;

	return (
		<Root>
			{primaryPercentage > 0 && (
				<ColorPieChart color={color} iconWidth={sizes.iconSize} percentage={primaryPercentage} sm={sm} />
			)}
			<PieChart
				color={secondaryPercentage > 0 ? 'var(--punchup-color-text-muted)' : 'transparent'}
				iconWidth={sizes.iconSize}
				percentage={secondaryPercentage}
				sm={sm}
			>
				<div className={styles.label} style={{ fontSize: sizes.fontSize }}>{`${percentage}%`}</div>
			</PieChart>
		</Root>
	);
};
